import { render, staticRenderFns } from "./HomeMiddle.vue?vue&type=template&id=6cc7c704&scoped=true&"
import script from "./HomeMiddle.vue?vue&type=script&lang=js&"
export * from "./HomeMiddle.vue?vue&type=script&lang=js&"
import style0 from "./HomeMiddle.vue?vue&type=style&index=0&id=6cc7c704&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc7c704",
  null
  
)

export default component.exports